import { GET, POST, PUT } from 'utils/requests.utils'
import { Response } from 'types/responses'
type ErrorData = {
  code: string
  type: string
  param: string
  docUrl: string
  message: string
}

type Prefs = {
  url: string
}

export type ElopageConnectLegitimation = {
  id: number
  state: string
  actionNeeded: boolean
  active: boolean
  bankAccountLegitimationId: number | null
  data: any | null
  defaultCurrencyId: number
  errorData: ErrorData | null
  extId: string
  internalState: string
  kind: string
  klarnaCapability: boolean
  monduCapability: boolean
  msg: string | null
  prefs: Prefs
  sofort: boolean
  twintCapability: boolean
  type: string
  userProfileId: number
  createdAt: string
  updatedAt: string
}

const BASE_URL = '/cabinet/settings/payment_setting/elopage_connect_legitimation'

const BANK_ACCOUNTS_URL = `${BASE_URL}/elopage_connect_bank_accounts`

const WALLETS_URL = `${BASE_URL}/elopage_connect_wallets`

export const fetchItem = () =>
  GET<Response<ElopageConnectLegitimation>>(`${BASE_URL}?expand[]=legitimation_documents`, { skipErrorNotific: true })
export const updateItem = (data) => PUT(BASE_URL, data)
export const createItem = (data) => POST(BASE_URL, data)

export const fetchBankAccountsList = (data) => GET(`${BANK_ACCOUNTS_URL}`, { ...data, skipErrorNotific: true })
export const createBankAccount = (data) => POST(`${BANK_ACCOUNTS_URL}`, data)
export const registerBankAccount = (id) => POST(`${BANK_ACCOUNTS_URL}/${id}/register`)

export const fetchWalletsList = () => GET(WALLETS_URL)
export const updateWallet = (id, data) => PUT(`${WALLETS_URL}/${id}`, data)

export const continueOnboarding = () => POST(`${BASE_URL}/onboarding_link`)

export const fetchRequirements = () => GET(`${BASE_URL}/requirements`)

export const fetchSupportedCurrencies = () => GET(`${BASE_URL}/supported_currencies`)
